import * as Popover from '@radix-ui/react-popover';
import { FolderOpen } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ScopeGate } from '@/auth/ScopeGate';
import { TemplateList } from './TemplateList';

/**
 * TopBar entry — a popover listing saved templates. Hidden entirely when
 * the user lacks `workbench:templates:read`.
 */
export function TemplatesMenu() {
  const { t } = useTranslation('common');
  const [open, setOpen] = useState(false);

  return (
    <ScopeGate need="workbench:templates:read" fallback={null}>
      <Popover.Root open={open} onOpenChange={setOpen}>
        <Popover.Trigger asChild>
          <button
            type="button"
            aria-label={t('templates.menuLabel')}
            className="rounded p-1 text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring"
          >
            <FolderOpen size={16} />
          </button>
        </Popover.Trigger>
        <Popover.Portal>
          <Popover.Content
            align="end"
            sideOffset={6}
            className="z-50 w-[320px] overflow-hidden rounded-md border border-border bg-popover text-popover-foreground shadow-wb-md"
          >
            <div className="border-b border-border px-3 py-2 text-xs font-semibold uppercase text-muted-foreground">
              {t('templates.listTitle')}
            </div>
            <TemplateList onClose={() => setOpen(false)} />
          </Popover.Content>
        </Popover.Portal>
      </Popover.Root>
    </ScopeGate>
  );
}
